import { AiFillCrown } from "react-icons/ai";
import { IoMdCloseCircle } from "react-icons/io";
import Tooltip from '@material-ui/core/Tooltip';
import { Container, IconButton } from "./styles";
import React from 'react';

const CommitteCard = ({name, onSetFinalElevation, finalElevation, onDelete}) => {
  return (
    <Container>
      <Tooltip aria-label="Definir como alçada final" title="Definir como alçada final">
        <IconButton>
          <AiFillCrown size={22} color={finalElevation ? '#fff259' : '#ffffffb3'} onClick={onSetFinalElevation} /> 
        </IconButton>
      </Tooltip>
      
      <span>
        {name}
      </span>


      <IoMdCloseCircle color="#fff" onClick={onDelete} size={22} />
    </Container>
  );
};

export default CommitteCard;